import React, { useState } from "react";

import { Tooltip } from "antd";

import styles from "./ClaimCard.module.css";

export const RemovedIdentityCard = ({ data }) => {
  const [isCopied, setIsCopied] = useState(false);

  function copyToClipboard(id) {
    let copyText = document.getElementById(id);
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }

  return (
    <div className="max-[500px]:px-0 border rounded-xl p-6 bg-[#b39dd4] flex flex-col gap-3">
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <label htmlFor={`removedIdentityTrustedIssuer-${data.id}`} className={`max-[500px]:text-sm ${styles.cardFieldLabel}`}>
          Trusted Issuer Wallet
        </label>
        <div className="flex gap-2 justify-center w-full">
          <input
            type="text"
            id={`removedIdentityTrustedIssuer-${data.id}`}
            name={`removedIdentityTrustedIssuer-${data.id}`}
            className={styles.cardField}
            value={data?.trustedIssuer || ""}
            readOnly
          ></input>
          <Tooltip title={isCopied ? "Copied!" : "Copy text!"}>
            <button onClick={() => copyToClipboard(`removedIdentityTrustedIssuer-${data.id}`)}>
              <img src={require("../images/copy-icon.png")} alt="Copy to Clipboard"></img>
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <p className="max-[500px]:text-sm">Trusted Issuer Email</p>
        <div className="flex gap-2 justify-center">
          <p className="max-[500px]:text-xs">{data?.trustedIssuerEmail || "N/A"}</p>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <label htmlFor={`removedIdentityTransactionHash-${data.id}`} className={`max-[500px]:text-sm ${styles.cardFieldLabel}`}>
          Transaction hash
        </label>
        <div className="flex gap-2 justify-center w-full">
          <input
            type="text"
            id={`removedIdentityTransactionHash-${data.id}`}
            name={`removedIdentityTransactionHash-${data.id}`}
            className={styles.cardField}
            value={data?.transactionHash || ""}
            readOnly
          ></input>
          <Tooltip title={isCopied ? "Copied!" : "Copy text!"}>
            <button onClick={() => copyToClipboard(`removedIdentityTransactionHash-${data.id}`)}>
              <img src={require("../images/copy-icon.png")} alt="Copy to Clipboard"></img>
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex justify-between max-[500px]:flex-col text-center">
        <p className="max-[500px]:text-sm">Date</p>
        <div className="flex gap-2 justify-center">
          <p className="max-[500px]:text-xs">
            {data?.createdAt
              ? new Date(data.createdAt).toLocaleDateString("en-us", {
                  weekday: "long",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
              : "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
};
